/**
 * Tablet styles
 * Styles specific to tablet devices, including iPad Mini, iPad Air, and iPad Pro
 */

// Tablet-specific styles for the container
export const tabletContainerStyles = {
  padding: '24px 0',
  width: '100%',
  backgroundColor: '#FFFFFF',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
};

// Tablet-specific styles for the title
export const tabletTitleStyles = {
  fontSize: '1.75rem',
  fontWeight: 600,
  textAlign: 'center',
  marginBottom: '24px',
  color: '#0A3954',
  width: '100%',
  padding: '0 24px'
};

// Tablet-specific styles for the grid layout
export const tabletGridStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  padding: '20px',
  alignItems: 'center',
  width: '100%'
};

// Tablet-specific styles for brand cards
export const tabletBrandCardStyles = {
  borderRadius: '12px',
  border: '1px solid rgba(0, 0, 0, 0.08)',
  height: '180px',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  width: '180px',
  flex: '0 0 180px',
  marginLeft: '8px',
  '&:first-of-type': {
    marginLeft: '16px',
  },
  '@media (min-width: 740px) and (max-width: 768px)': {
    width: '180px',
    flex: '0 0 180px',
    height: '180px',
  },
  '@media (min-width: 800px) and (max-width: 834px)': {
    width: '200px',
    flex: '0 0 200px',
    height: '200px',
  },
};

// Tablet-specific styles for brand image container
export const tabletBrandImageContainerStyles = {
  padding: '16px',
  '@media (min-width: 740px) and (max-width: 768px)': {
    padding: '16px',
  },
  '@media (min-width: 800px) and (max-width: 834px)': {
    padding: '18px',
  },
};

// Tablet-specific styles for brand name container
export const tabletBrandNameStyles = {
  padding: '10px',
};

// Tablet-specific styles for brand typography
export const tabletBrandTypographyStyles = {
  fontSize: '1rem',
  textAlign: 'center',
  '@media (min-width: 740px) and (max-width: 768px)': {
    fontSize: '1rem',
  },
  '@media (min-width: 800px) and (max-width: 834px)': {
    fontSize: '1.1rem',
  },
};

// iPad Mini specific styles
export const iPadMiniBrandCardStyles = {
  width: '150px',
  height: '125px'
};

export const iPadMiniBrandImageContainerStyles = {
  height: '85px'
};

export const iPadMiniBrandTypographyStyles = {
  fontSize: '0.8125rem'
};

// iPad Air specific styles
export const iPadAirBrandCardStyles = {
  width: '160px',
  height: '130px'
};

export const iPadAirBrandImageContainerStyles = {
  height: '90px'
};

export const iPadAirBrandTypographyStyles = {
  fontSize: '0.875rem'
};

// iPad Pro specific styles
export const iPadProBrandCardStyles = {
  width: '180px',
  height: '140px'
};

export const iPadProBrandImageContainerStyles = {
  height: '100px'
};

export const iPadProBrandTypographyStyles = {
  fontSize: '0.9375rem'
};

// Tablet-specific styles for BrandsCarousel.
export const tabletCarouselContainerStyles = {
  '.slick-track': {
    gap: '12px',
  },
  '.slick-slide': {
    margin: '0 8px',
  },
  '.slick-list': {
    margin: '0 -8px',
    overflow: 'visible',
    paddingLeft: 0,
    paddingRight: 0,
  },
  overflowX: 'auto',
  marginLeft: 0,
  marginRight: 0,
  paddingLeft: 0,
  paddingRight: 0,
  '@media (min-width: 600px) and (max-width: 899px)': {
    width: '100%',
    maxWidth: '100vw',
  },
  '@media (min-width: 740px) and (max-width: 768px)': {
    '.slick-track': {
      gap: '10px',
    },
  },
  '@media (min-width: 800px) and (max-width: 834px)': {
    '.slick-track': {
      gap: '12px',
    },
  },
};

// Tablet alternative styles
export const tabletAlternativeBrandCardStyles = {
  ...tabletBrandCardStyles,
};

export const tabletAlternativeBrandImageContainerStyles = {
  ...tabletBrandImageContainerStyles,
};

export const tabletAlternativeBrandNameStyles = {
  ...tabletBrandNameStyles,
};

export const tabletAlternativeBrandTypographyStyles = {
  ...tabletBrandTypographyStyles,
};

// Styles moved from TabletCarousel.js
export const tabletCarouselContainerStylesAlt = { // Renamed to avoid conflict
  marginTop: '16px',
  width: '100%',
  overflow: 'hidden'
};

export const tabletCarouselGridStylesAlt = { // Renamed to avoid conflict
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: '20px',
  justifyContent: 'center',
  padding: '0 16px',
  width: '100%'
}; 